import http from "@/utils/request";

// 查询PSA详情
export function fetchIllustrateDetail(no) {
  return http.request({
    url: `/api/manager-service/illustrate/detail?no=${no}`,
    method: "GET",
  });
}

// 查询分类
export function fetchCategoryList(data) {
  return http.request({
    url: `/api/manager-service/category/query/mp`,
    method: "POST",
    data,
  });
}

// 卡牌列表
export function fetchCardList(data) {
  return http.request({
    url: `/api/manager-service/shopCard/search`,
    method: "POST",
    data,
  });
}

// 保存图鉴
export function createIllustrate(data) {
  return http.request({
    url: `/api/manager-service/illustrate/create`,
    method: "POST",
    data,
  });
}


// ----送拍---------------------------------------------------

// 子订单列表
export function fetchAuctionSubOrderList(data) {
  return http.request({
    url: `/api/paipika-service/illustrate/manage/auction/subOrderList`,
    method: "POST",
    data,
  });
}

// 送拍修改状态
export function fetchAuctionStatusAdjust(data) {
  return http.request({
    url: `/api/paipika-service/illustrate/manage/auction/batchChangeStatus`,
    method: "POST",
    data,
  });
}

// 批量处理订单
export function fetchBackDealOrder(data) {
  return http.request({
    url: `/api/paipika-service/illustrate/manage/auction/backDealOrder`,
    method: "POST",
    data,
  });
}

// 寄售订单填写快递单号
export function fetchAuctionShippingInfo(data) {
  return http.request({
    url: `/api/paipika-service/illustrate/manage/auction/writeBackEmailNo`,
    method: "POST",
    data,
  });
}

// 日本仓下单设置
export function fetchAuctionWriteKaleOrderNo(data) {
  return http.request({
    url: `/api/paipika-service/illustrate/manage/auction/writeKaleOrderNo`,
    method: "POST",
    data,
  });
}

// ----送评---------------------------------------------------
// 20251227更新-----------------------------------------------------------------------------------------
// 查询卡乐送评分类
export function fetchCommentCategories() {
  return http.request({
    url: `/api/manager-service/illustrate/comment/categories`,
    method: "GET",
  });
}
// 查询送评分类下的产品
export function fetchCommentGoodsCategory(categoryId) {
  return http.request({
    url: `/api/manager-service/illustrate/comment/goods/${categoryId}`,
    method: "GET",
  });
}
// 修改卡乐送评产品信息
export function fetchCommentGoodsModify(data) {
  return http.request({
    url: `/api/manager-service/illustrate/comment/goods/modify`,
    method: "POST",
    data
  });
}
// 分页查询卡乐送评订单
export function fetchCommentQueryPage(data) {
  return http.request({
    url: `/api/manager-service/illustrate/comment/query/page`,
    method: "POST",
    data
  });
}
// 修改送评订单状态
export function fetchCommentStatusModify(data) {
  return http.request({
    url: `/api/manager-service/illustrate/comment/status/modify`,
    method: "POST",
    data
  });
}
// 查询送评子订单
export function fetchCommentGoodsItem(orderNo) {
  return http.request({
    url: `/api/manager-service/illustrate/comment/item/query/${orderNo}`,
    method: "GET",
  });
}
// PSA匹配卡库
export function fetchCommentMatch(data) {
  return http.request({
    url: `/api/manager-service/illustrate/match`,
    method: "POST",
    data
  });
}
// 完成送评子订单
export function fetchCommentItemComplete(data) {
  return http.request({
    url: `/api/manager-service/illustrate/comment/item/complete`,
    method: "POST",
    data
  });
}

// 通过订单创建图鉴
export function fetchIllustrateCreateOrder(data) {
  return http.request({
    url: `/api/manager-service/illustrate/create/order`,
    method: "POST",
    data
  });
}
// 日本仓库寄送订单
export function fetchCommentWarehouseShip(data) {
  return http.request({
    url: `/api/manager-service/illustrate/comment/warehouse/ship`,
    method: "POST",
    data
  });
}
// 修改送评产品信息
export function fetchProductsGoodsModify(data) {
  return http.request({
    url: `/api/manager-service/illustrate/comment/goods/modify`,
    method: "POST",
    data
  });
}